import type { AppLocale } from '@/constants/appLocale';
import { isAppLocale } from '@/constants/appLocale';
import * as enUS from './en_US';
import * as jaJP from './ja_JP';
import * as koKR from './ko_KR';
import * as zhCN from './zh_CN';
import * as zhTW from './zh_TW';

const byLocale: Record<AppLocale, { title: string; body: string }> = {
  ja_JP: { title: jaJP.privacyTitle, body: jaJP.privacyBody },
  zh_CN: { title: zhCN.privacyTitle, body: zhCN.privacyBody },
  zh_TW: { title: zhTW.privacyTitle, body: zhTW.privacyBody },
  en_US: { title: enUS.privacyTitle, body: enUS.privacyBody },
  ko_KR: { title: koKR.privacyTitle, body: koKR.privacyBody },
};

export function getPrivacyContent(language: string) {
  if (isAppLocale(language)) return byLocale[language];
  return byLocale.zh_CN;
}
